import { render, staticRenderFns } from "./BaseTableColumnasMedatados.vue?vue&type=template&id=a7776c6c&"
import script from "./BaseTableColumnasMedatados.vue?vue&type=script&lang=js&"
export * from "./BaseTableColumnasMedatados.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports